module.exports = __webpack_public_path__ + "img/sozialschnellgut_9_b.1fbbedca.jpg";